import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppCtrl from "../../../control/AppCtrl";
import useAlert from "../../../hook/useAlert";
import useAtgGames from "../../../redux/atgGames/atgGamesAction";
import useLobbies from "../../../redux/lobbies/lobbiesAction";
import useRsgGames from "../../../redux/rsgGames/rsgGamesAction";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import Config from "../../../utils/Config";
import EPage from "../../../utils/EPage";
import EFunction from "../../../utils/FunctionPage";
import LANGUAGE_TYPE from "../../../utils/Language";
import ScreenOrientation from "../../../utils/Orientation";
import Utils from "../../../utils/Utils";
import BroadcastPanel from "../../BroadcastPanel";
import Banners from "./Banners";
import styles from "./index.module.scss";

const uiLobbiesBtns = [];
const uiUniStoreBtns = [];
let registerEventTimeout = null;
var mLobbies = null;
var mbannersContent = null;
var mSliderBannerTimer = null;
var mBannerCounter = 0;
var mBannerIndex = 0;
var mSetBonus = false;

function WinLobbyPage() {
  const text = Config.text.winLobbyPage;
  const broadcastHeight = 45;
  const headerHeight = 40;
  const footerHeight = 95;
  const userInfoPageHeight = 70;

  // const forcePcMode = Config.forcePCMode ? Config.forcePCMode : false;
  // var mobileMode = Utils.detectmob() && !forcePcMode;
  // 使用函數初始化確保只讀取一次，且在 Config 已加載時
  const [forceVerticalMode] = useState(() =>
    Config.forceVerticalMode ? Config.forceVerticalMode : false
  );
  const [mobileMode] = useState(() => Utils.detectmob() || forceVerticalMode);
  // const [forcePcMode, setForcePcMode] = useState(false);
  // const [mobileMode, setMobileMode] = useState(false);

  const { setFunc } = switchFunc();
  const { lobbies } = useLobbies();
  const { userCoins } = useUserCoins();
  const { showAlert, isVisible } = useAlert();
  const { games: atgGames } = useAtgGames();
  const { games: rsgGames } = useRsgGames();
  const navigate = useNavigate();
  //===========================================================================
  const [avatar, setAvatar] = useState(false);
  const [userUniPlayScores, setUserUniPlayScores] = useState(0);
  const [scoresFormalToUniPlay, setScoresFormalToUniPlay] = useState(0);
  const [uniPlayStartDisabled, setUniPlayStartDisabled] = useState(false);
  const [uniPlayInfo, setUniPlayInfo] = useState(null);

  const containerRef = useRef(null);
  const iframeRef = useRef(null);

  // 機器人：自動進 Lobby 計時器
  const robotLobbyTimerRef = useRef(null);
  // 新增：倒數顯示與 interval
  const robotLobbyIntervalRef = useRef(null);
  const robotLobbyCountdownRef = useRef(0);
  const [robotLobbyCountdown, setRobotLobbyCountdown] = useState(null);

  // 新增 protocol 的 useRef
  const protocolRef = useRef("http");
  // useEffect(() => {
  //   // 確保在組件完全掛載後讀取配置
  //   const pcMode = Config.forcePCMode ? Config.forcePCMode : false;
  //   setForcePcMode(pcMode);
  //   setMobileMode(Utils.detectmob() && !pcMode);
  // }, []);

  useEffect(() => {
    PreLoad();
    componentDidMount();
    return componentWillUnmount;
  }, []);

  // 在 useEffect 中初始化 protocol
  useEffect(() => {
    const getProtocol = () => {
      try {
        const middleServer = AppCtrl.middleServer();
        return middleServer && middleServer.getProtocol
          ? middleServer.getProtocol()
          : "http";
      } catch (error) {
        console.warn(
          "Failed to get protocol from AppCtrl, using default http:",
          error
        );
        return "http";
      }
    };

    protocolRef.current = getProtocol();
  }, []); // 只在組件掛載時執行一次

  useEffect(() => {
    if (Config.logingFromMachine) {
      const uiExitButton = document.getElementById("exitButton");
      if (uiExitButton) {
        uiExitButton.disabled = true;
        uiExitButton.style.opacity = 0.5;
      }

      const uiExitavatarButton = document.getElementById("exitavatarButton");
      if (uiExitavatarButton) {
        uiExitavatarButton.disabled = false;
        uiExitavatarButton.style.opacity = 1.0;
      }

      const uiChatButton = document.getElementById("chatButton");
      if (uiChatButton) {
        uiChatButton.disabled = true;
        uiChatButton.style.opacity = 0.5;
      }

      const uiBtnStore = document.getElementById("btnStore");
      if (uiBtnStore) {
        uiBtnStore.disabled = true;
        uiBtnStore.style.opacity = 0.5;
      }

      const uiBtnWallet = document.getElementById("btnWallet");
      if (uiBtnWallet) {
        uiBtnWallet.disabled = true;
        uiBtnWallet.style.opacity = 0.5;
      }

      const uiBtnSettings = document.getElementById("btnSettings");
      if (uiBtnSettings) {
        uiBtnSettings.disabled = true;
        uiBtnSettings.style.opacity = 0.5;
      }
    }
  }, [avatar]);

  useEffect(() => {
    let body = document.querySelector("body");
    if (mobileMode) {
      //if (!mobileMode) {
      body.style.overflowY = "auto";
    }
    const mainSettings = AppCtrl.mainSettings();
    const language = AppCtrl.getLanguage();
    const userInfo = AppCtrl.userInfo();
    setAvatar(userInfo.AvatarInfo ? true : false);

    const uiBtnUniPlay = document.getElementById("btnUniPlay");
    const ShowUniPlay = Config.showUniPlay ? Config.showUniPlay : false;
    if (uiBtnUniPlay && !ShowUniPlay) {
      uiBtnUniPlay.disabled = true;
      uiBtnUniPlay.style.opacity = 0.5;
      //uiBtnUniPlay.style.display = "none";
    }
    const uiShowTitle = document.getElementById("showTitle");
    const ShowTitle = Config.showTitle ? Config.showTitle : Config.casinoName;
    if (uiShowTitle && ShowTitle != "") {
      uiShowTitle.innerHTML = ShowTitle;
    }

    const uiChatButton = document.getElementById("chatButton");
    const liveChat = Config.liveChat ? Config.liveChat : "";
    const withAPIGame = Config?.withAPIGame ?? false;
    if ((uiChatButton && liveChat === "") || withAPIGame) {
      uiChatButton.disabled = true;
      uiChatButton.style.opacity = 0.5;
    }

    const uiBtnSettings = document.getElementById("btnSettings");
    const ShowSetting = Config.showSettings ? Config.showSettings : false;
    if (uiBtnSettings && !ShowSetting) {
      uiBtnSettings.disabled = true;
      uiBtnSettings.style.opacity = 0.5;
    }

    const uiBtnWallet = document.getElementById("btnWallet");
    const ShowGift = Config.showGift ? Config.showGift : false;
    if (uiBtnWallet && !ShowGift) {
      uiBtnWallet.disabled = true;
      uiBtnWallet.style.opacity = 0.5;
      //uiBtnWallet.style.display = "none";
    }

    const uiBtnRecords = document.getElementById("btnRecords");
    if (uiBtnRecords && !Config.showGiftRecords && !Config.showPlayRecords) {
      uiBtnRecords.disabled = true;
      uiBtnRecords.style.opacity = 0.5;
    }

    const uiBtnStore = document.getElementById("btnStore");
    const showStore = Config.showStore;
    const useStore = userInfo.UserUseStoreState === 2;
    const shouldDisableBtn = !showStore || !useStore; // 判斷按鈕是否要禁用
    if (uiBtnStore) {
      uiBtnStore.disabled = shouldDisableBtn; // 設定按鈕 disabled 屬性
      uiBtnStore.style.opacity = shouldDisableBtn ? 0.5 : 1; // 調整透明度
      if (Config.logingFromMachine) {
        uiBtnStore.disabled = true;
        uiBtnStore.style.opacity = 0.5;
      }
    }

    const uiUserInfos = document.getElementById("userInfos");
    if (uiUserInfos) {
      const goldName = Config.gold[language];
      const silverName = Config.silver[language];
      const wainZhusName = Config.wainZhuName[language];
      const paiedAwardName = Config.paiedAwardName[language];
      const betRewardName = Config.betRewardName[language];
      const guoZhaoInfo = userInfo.GuoZhaoInfo;
      const specialCoinName = Config.specialCoins[language];
      const specialCoinNameA = Config.specialCoinsA[language];

      let content =
        '<div style="padding:2px; background-color:rgba(0, 0, 0, 0.2); border-radius:10px">';
      if (language == LANGUAGE_TYPE.en_US) {
        content += `<div>User: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (on Guo Zhao, Machine ${machineName} of Lobby ${guoZhaoInfo.Lobby})`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (use Machine ${machineName} of Lobby ${lockedMachine.Lobby})`;
        }
        content += "</div>";
      } else {
        const now = new Date();
        const dateStr = now.toLocaleString("zh-TW", {
          hour12: false,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        content += `<div>${dateStr}</div>`;

        content += `<div>玩家: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (正在${guoZhaoInfo.Lobby}館的機台${machineName}過招中)`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (使用${lockedMachine.Lobby}館的機台${machineName})`;
        }
        content += "</div>";
      }
      content += `<div>${goldName}: ${(
        userInfo.InCoins - userInfo.OutCoins
      ).toLocaleString()}</div>`;
      if (Config.trialCoins) {
        content += "<div>";
        content += `<span>${silverName}: ${(
          userInfo.InTrialCoins - userInfo.OutTrialCoins
        ).toLocaleString()}</span>`;
        if (userInfo.PaiedAward != null)
          content += `<span style="margin-left:20px">${paiedAwardName}: ${userInfo.PaiedAward.toLocaleString()}</span>`;
        content += "</div>";
      }
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinName}: ${(
          userInfo.InSpecialCoins - userInfo.OutSpecialCoins
        ).toLocaleString()}</div>`;
      }
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinNameA}: ${(
          userInfo.InSpecialCoinsA - userInfo.OutSpecialCoinsA
        ).toLocaleString()}</div>`;
      }
      if (Config.wainZhu && userInfo.WainZhus != null) {
        if (typeof userInfo.WainZhus != "object")
          AppCtrl.setWainZhu(userInfo.WainZhus);
        const wainZhu = AppCtrl.WainZhu();
        content += `<div>${wainZhusName}:${wainZhu.toLocaleString()}</div>`;
      }
      if (mainSettings.ShowBetReward && userInfo.BetReward != null) {
        content += "<div>";
        content += `<span>${betRewardName}: ${userInfo.BetReward.toLocaleString()}</span>`;
        content += "</div>";
      }
      const showPlayerLevel = AppCtrl.showPlayerLevel();
      if (showPlayerLevel > 0) {
        //img:"img/gamelobby/銀卡.png",
        const permission =
          userInfo.Permission >= showPlayerLevel
            ? showPlayerLevel
            : userInfo.Permission;
        const imgLevel = `img/gamelobby/VipCard${permission.toString()}.png`;

        // content += `<div id='VipCard'>
        //         <img src="${imgLevel}" style="position:relative; left:0; top:10px; width:30%; object-fit:contain"/>
        //         </div>`;
      }
      content += "</div>";
      uiUserInfos.innerHTML = content;
    }

    const userInfos_horizontalmode = document.getElementById(
      "userInfos_horizontalmode"
    );
    if (userInfos_horizontalmode) {
      // //------------------UserInfos------------------
      const mainSettings = AppCtrl.mainSettings();
      const language = AppCtrl.getLanguage();
      const userInfo = AppCtrl.userInfo();
      const goldName = Config.gold[language];
      const silverName = Config.silver[language];
      const wainZhusName = Config.wainZhuName[language];
      const paiedAwardName = Config.paiedAwardName[language];
      const betRewardName = Config.betRewardName[language];
      const guoZhaoInfo = userInfo.GuoZhaoInfo;
      const specialCoinName = Config.specialCoins[language];
      const specialCoinNameA = Config.specialCoinsA[language];

      const deviceHeight = window.innerHeight;
      const contentHeight = deviceHeight - 90 - 85; //BTNTopBar-horizontal(40px)+broadcastPanel(30px);+content_horizontal(85px)
      const infoHeight = contentHeight * 0.6;
      const infoWidth = infoHeight;
      const topOffsetInfo = (contentHeight - infoHeight) / 2;

      let userInfosContent = "";
      let content = "";
      //顯示玩家暱稱
      if (language == LANGUAGE_TYPE.en_US) {
        content += `<div>User: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (on Guo Zhao, Machine ${machineName} of Lobby ${guoZhaoInfo.Lobby})`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (use Machine ${machineName} of Lobby ${lockedMachine.Lobby})`;
        }
        content += "</div>";
      } else {
        const now = new Date();
        const dateStr = now.toLocaleString("zh-TW", {
          hour12: false,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        content += `<div>${dateStr}</div>`;

        content += `<div>玩家: ${userInfo.nickName()}`;
        if (guoZhaoInfo != null) {
          const machineName = guoZhaoInfo.Machine
            ? guoZhaoInfo.Machine
            : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
          content += ` (正在${guoZhaoInfo.Lobby}館的機台${machineName}過招中)`;
        } else if (userInfo.BindedMachines.length > 0) {
          const lockedMachine = userInfo.BindedMachines[0];
          const machineName = lockedMachine.MachineName
            ? lockedMachine.MachineName
            : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
          content += ` (使用${lockedMachine.Lobby}館的機台${machineName})`;
        }
        content += "</div>";
      }

      //顯示玩家的金幣數量
      content += `<div>${goldName}: ${(
        userInfo.InCoins - userInfo.OutCoins
      ).toLocaleString()}</div>`;

      //顯示玩家的銀幣數量
      if (Config.trialCoins) {
        content += `<div>${silverName}: ${(
          userInfo.InTrialCoins - userInfo.OutTrialCoins
        ).toLocaleString()}</div>`;
      }

      //顯示玩家的特殊幣數量
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinName}: ${(
          userInfo.InSpecialCoins - userInfo.OutSpecialCoins
        ).toLocaleString()}</div>`;
      }
      if (Config.showSpecialCoin) {
        content += `<div>${specialCoinNameA}: ${(
          userInfo.InSpecialCoinsA - userInfo.OutSpecialCoinsA
        ).toLocaleString()}</div>`;
      }

      //顯示玩家的每日贈獎數量
      if (userInfo.PaiedAward != null) {
        content += `<div">${paiedAwardName}: ${userInfo.PaiedAward.toLocaleString()}
          </div>`;
      }

      //顯示玩家返水數量
      if (mainSettings.ShowBetReward && userInfo.BetReward != null) {
        content += `<div>${betRewardName}: ${userInfo.BetReward.toLocaleString()}
          </div>`;
      }

      //顯示玩家萬珠數量,目前已經停用
      if (Config.wainZhu && userInfo.WainZhus != null) {
        if (typeof userInfo.WainZhus != "object")
          AppCtrl.setWainZhu(userInfo.WainZhus);
        const wainZhu = AppCtrl.WainZhu();
        content += `<div>${wainZhusName}:${wainZhu.toLocaleString()}
          </div>`;
      }

      //顯示玩家等級
      const showPlayerLevel = AppCtrl.showPlayerLevel();
      if (showPlayerLevel > 0) {
        //img:"img/gamelobby/銀卡.png",
        const permission =
          userInfo.Permission >= showPlayerLevel
            ? showPlayerLevel
            : userInfo.Permission;
        const imgLevel = `img/gamelobby/VipCard${permission.toString()}.png`;
        const cardWidth = 0.3 * infoWidth; // 30% of infoWidth

        content += `<div id='VipCard'> 
                <img src="${imgLevel}" style="position:absolute;right:0px;top:${topOffsetInfo}px;
                padding-top:200px; width:${cardWidth}px; object-fit:contain"/>
                </div>`;
      }
      userInfosContent += content;
      userInfosContent += `</div></div>`;
      // //------------------End UserInfos------------------
      userInfos_horizontalmode.innerHTML = userInfosContent;
    }
  }, [userCoins]);

  useEffect(() => {
    const userInfo = AppCtrl.userInfo();
    setAvatar(userInfo.AvatarInfo ? true : false);
  }, [lobbies]);

  useEffect(() => {
    if (lobbies) {
      unregisterEvent();
      unregisterUniStoreEvent();
      buildLobbiesUI(lobbies);

      const uiwinLobbies = document.getElementById("winLobbies");
      if (uiwinLobbies) {
        if (registerEventTimeout) clearTimeout(registerEventTimeout);
        registerEventTimeout = setTimeout(function () {
          registerEvent();
          // show ui
          //Start
          const prefix = "lobby_";
          const uniPlayList = AppCtrl.uniPlayList();
          uniPlayList.forEach((info) => {
            //info.name,
            const UniStore = `${info.name}`; //`uniStore`;
            const uiBtnUniStore = document.getElementById(
              `${prefix}${UniStore}`
            );
            if (uiBtnUniStore) {
              if (!AppCtrl.isStartUniPlay())
                //!avatar) )
                uiBtnUniStore.style.display = "";
              else {
                unregisterUniStoreEvent();
                uiBtnUniStore.remove();
              }
            }
          });
          //End
          registerEventTimeout = null;
        }, 1000);
      }
    }
  }, [lobbies]);

  // 大廳列表變更後（或初次載入），若為機器人模式則 5 秒後嘗試進入指定 Lobby
  useEffect(() => {
    if (!AppCtrl.isRobotMode()) return; // 僅在機器人模式執行
    if (!Array.isArray(lobbies) || lobbies.length === 0) return;

    // 清舊的 timer/interval
    if (robotLobbyTimerRef.current) {
      clearTimeout(robotLobbyTimerRef.current);
      robotLobbyTimerRef.current = null;
    }
    if (robotLobbyIntervalRef.current) {
      clearInterval(robotLobbyIntervalRef.current);
      robotLobbyIntervalRef.current = null;
    }

    // 啟動 5 秒倒數顯示
    robotLobbyCountdownRef.current = 3;
    setRobotLobbyCountdown(3);
    robotLobbyIntervalRef.current = setInterval(() => {
      const next = robotLobbyCountdownRef.current - 1;
      robotLobbyCountdownRef.current = next;
      setRobotLobbyCountdown(next);
      if (next <= 0) {
        clearInterval(robotLobbyIntervalRef.current);
        robotLobbyIntervalRef.current = null;
      }
    }, 1000);

    // 5 秒到自動進入指定 Lobby
    robotLobbyTimerRef.current = setTimeout(() => {
      robotLobbyTimerRef.current = null;
      const idx = Number(
        AppCtrl.getRobotLobbyNum ? AppCtrl.getRobotLobbyNum() : -1
      );
      if (Number.isInteger(idx) && idx >= 0 && idx < lobbies.length) {
        const lobbyName = lobbies[idx]?.name;
        if (lobbyName) AppCtrl.joinLobby(lobbyName);
      }
      // 倒數結束，隱藏顯示
      setRobotLobbyCountdown(null);
    }, 5000);

    return () => {
      if (robotLobbyTimerRef.current) {
        clearTimeout(robotLobbyTimerRef.current);
        robotLobbyTimerRef.current = null;
      }
      if (robotLobbyIntervalRef.current) {
        clearInterval(robotLobbyIntervalRef.current);
        robotLobbyIntervalRef.current = null;
      }
      setRobotLobbyCountdown(null);
    };
  }, [lobbies]);

  //===========================================================================
  function PreLoad() {
    //Start
    const uniPlayCheckSkip = AppCtrl.uniPlayCheckSkip();
    if (Config.showUniPlay && !uniPlayCheckSkip) {
      AppCtrl.setUniPlayCheckSkip(true);
      //const prefix = "lobby_";
      const uniPlayList = AppCtrl.uniPlayList();
      uniPlayList.forEach((info) => {
        onStartUniPlay(info.name)
          .then(() => {
            AppCtrl.connectToServer(null, function () {
              AppCtrl.requestConfig();
              //send request token
              const account = AppCtrl.cacheAccount();
              const password = AppCtrl.cachePassword();
              AppCtrl.requestLoginToken(
                account,
                password,
                true,
                function (objRes) {
                  const status = objRes.status;
                  const language = AppCtrl.getLanguage();

                  if (status == "success") {
                    AppCtrl.stopUniPlay(function (objResStopUniPlay) {
                      if (objResStopUniPlay) setUniPlayInfo(null);
                      AppCtrl.stopUniPlayProcess(objResStopUniPlay).then(() => {
                        console.log("stopUniPlayProcess 已執行完成");
                      });
                    });
                  } else {
                    const err = objRes.error;
                    //   AppCtrl.alert(err);
                    if (!AppCtrl.isRobotMode()) {
                      showAlert({ title: err });
                    }
                  }
                }
              );
            });
          })
          .catch((error) => {
            console.error("startUniPlay 失敗:", error);
          });
      });
      //End
    }
    const menuBtns = [];
    const uiBtnSettings = document.getElementById("btnSettings");
    if (uiBtnSettings) {
      if (Config.showSettings) {
        menuBtns.push(uiBtnSettings);
      } else {
        //uiBtnSettings.style.display = "none";
      }
    }
    const uiBtnWallet = document.getElementById("btnWallet");
    if (uiBtnWallet) {
      menuBtns.push(uiBtnWallet);
    }
    const uiBtnRecords = document.getElementById("btnRecords");
    if (uiBtnRecords) {
      menuBtns.push(uiBtnRecords);
    }
    const uiBtnStore = document.getElementById("btnStore");
    if (uiBtnStore) {
      menuBtns.push(uiBtnStore);
    }
    const uiBtnUniPlay = document.getElementById("btnUniPlay");
    if (uiBtnUniPlay) {
      menuBtns.push(uiBtnUniPlay);
    }
    const menuBtnWidth = `${Math.floor(95 / menuBtns.length)}%`;
    for (let i = 0; i < menuBtns.length; i++) {
      menuBtns[i].style.width = menuBtnWidth;
    }
    AppCtrl.setInLobby(false);
    if (Config.logingFromMachine) {
      const uiExitButton = document.getElementById("exitButton");
      if (uiExitButton) {
        uiExitButton.disabled = true;
        uiExitButton.style.opacity = 0.5;
      }

      const uiChatButton = document.getElementById("chatButton");
      if (uiChatButton) {
        uiChatButton.disabled = true;
        uiChatButton.style.opacity = 0.5;
      }

      const uiBtnStore = document.getElementById("btnStore");
      if (uiBtnStore) {
        uiBtnStore.disabled = true;
        uiBtnStore.style.opacity = 0.5;
      }

      const uiBtnWallet = document.getElementById("btnWallet");
      if (uiBtnWallet) {
        uiBtnWallet.disabled = true;
        uiBtnWallet.style.opacity = 0.5;
      }

      const uiBtnSettings = document.getElementById("btnSettings");
      if (uiBtnSettings) {
        uiBtnSettings.disabled = true;
        uiBtnSettings.style.opacity = 0.5;
      }
    }
  }

  function componentDidMount() {
    if (Config.fullScreenLockMachine === true) {
      Utils.enterFullScreen();
    }
    const checkOrientationInLobby = AppCtrl.CheckOrientationInLobby();
    if (checkOrientationInLobby) {
      AppCtrl.SetOrientationInLobby(ScreenOrientation.LandscapePrimary);
      AppCtrl.LandscapePortraitSetInLobby(ScreenOrientation.LandscapePrimary);
    }

    window.addEventListener("resize", () => {
      calculateScale();
    });

    calculateScale();
    rebuilLobbies();
    // Listen for orientation change
    //screen.orientation.addEventListener('change', rebuilLobbiesEvent);
    const language = AppCtrl.getLanguage();
    let msg = "";
    if (language == LANGUAGE_TYPE.en_US) {
      if (AppCtrl.getCookie("lobbyName"))
        msg += "\r\nLast Time Lobby:" + AppCtrl.getCookie("lobbyName");
      if (AppCtrl.getCookie("machineName"))
        msg += "\r\nLast Time Machine:" + AppCtrl.getCookie("machineName");
    } else {
      if (AppCtrl.getCookie("lobbyName"))
        msg += "\r\n上次遊戲廳別:" + AppCtrl.getCookie("lobbyName");
      if (AppCtrl.getCookie("machineName"))
        msg += "\r\n上次機台選項:" + AppCtrl.getCookie("machineName");
    }

    //if (msg && !Swal.isVisible()) showAlert({ title: msg });
    if (msg && !isVisible()) {
      if (!AppCtrl.isRobotMode()) {
        showAlert({ title: msg });
      }
    }
  }

  function componentWillUnmount() {
    if (mSliderBannerTimer) clearInterval(mSliderBannerTimer);
    mSliderBannerTimer = null;
    unregisterEvent();
    unregisterUniStoreEvent();

    // 清除機器人自動進 Lobby 計時器與倒數
    if (robotLobbyTimerRef.current) {
      clearTimeout(robotLobbyTimerRef.current);
      robotLobbyTimerRef.current = null;
    }
    if (robotLobbyIntervalRef.current) {
      clearInterval(robotLobbyIntervalRef.current);
      robotLobbyIntervalRef.current = null;
    }
    setRobotLobbyCountdown(null);
  }

  // 簡易格式化 mm:ss
  function formatCountdown(sec) {
    if (sec == null) return "";
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  function calculateScale() {
    if (containerRef.current && iframeRef.current) {
      const containerWidth = containerRef.current.clientWidth;
      const containerHeight = containerRef.current.clientHeight;
      const scaleX = containerWidth / 1920;
      const scaleY = containerHeight / 1080;
      const scale = Math.min(scaleX, scaleY);
      containerRef.current.height = `${1080 * scale + 30}px`;

      iframeRef.current.style.transform = `scale(${scale})`;
    }
  }

  function onSettings() {
    setFunc(EFunction.settings);
  }

  function onWallet() {
    const language = AppCtrl.getLanguage();
    const mainSettings = AppCtrl.mainSettings();
    const userInfo = AppCtrl.userInfo();
    if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
      setFunc(EFunction.verifyPhone);
      // navigate('/verify-phone');
      if (language == LANGUAGE_TYPE.en_US) {
        if (!AppCtrl.isRobotMode()) {
          showAlert({ title: "Verify account to enjoy more benefit." });
        }
      }
      // AppCtrl.alert("Verify account to enjoy more benefit.");
      else {
        if (!AppCtrl.isRobotMode()) {
          showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
        }
      }
      // AppCtrl.alert("驗證帳號能享受更多遊戲權利。");
    } else {
      setFunc(EFunction.wallet);
      // navigate('/wallet');
      // update user scores
      AppCtrl.getUserScores();
    }
  }

  function onRecords() {
    setFunc(EFunction.records);
    // navigate('/records');
  }

  function onStore() {
    const mainSettings = AppCtrl.mainSettings();
    const userInfo = AppCtrl.userInfo();
    if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
      setFunc(EFunction.verifyPhone);
      // navigate('/verify-phone');
      if (language == LANGUAGE_TYPE.en_US) {
        if (!AppCtrl.isRobotMode()) {
          showAlert({ title: "Verify account to enjoy more benefit." });
        }
      } else {
        if (!AppCtrl.isRobotMode()) {
          showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
        }
      }
    } else {
      setFunc(EFunction.store);
      // navigate('/store');
    }
  }

  function onUniPlay() {
    const mainSettings = AppCtrl.mainSettings();
    const domainUrl = mainSettings.Domain;
    if (domainUrl && domainUrl.length > 0) {
      const userInfo = AppCtrl.userInfo();
      if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
        setFunc(EFunction.verifyPhone);
        // navigate('/verify-phone');
        if (language == LANGUAGE_TYPE.en_US) {
          if (!AppCtrl.isRobotMode()) {
            showAlert({ title: "Verify account to enjoy more benefit." });
          }
        } else {
          if (!AppCtrl.isRobotMode()) {
            showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
          }
        }
      } else {
        setFunc(EFunction.uniPlay);
        // navigate('/play');
      }
    } else {
      const uiBtnUniPlay = document.getElementById("btnUniPlay");
      if (uiBtnUniPlay) uiBtnUniPlay.disabled = true;
    }
  }
  //onChat
  function onChat() {
    const liveChat = Config.liveChat ? Config.liveChat : "";
    const withAPIGame = Config?.withAPIGame ?? false;
    if (liveChat != "" && !withAPIGame) {
      window.open(liveChat);
    }
  }
  function onExitGame() {
    const language = AppCtrl.getLanguage();
    const checkOrientationInLobby = AppCtrl.CheckOrientationInLobby();
    let message;
    let yesText;
    let noText;
    if (language == LANGUAGE_TYPE.en_US) {
      message = "This action will do logout, are you sure?";
      yesText = "Yes";
      noText = "No";
    } else {
      message = "將登出目前帳號，確定嗎?";
      yesText = "確定";
      noText = "取消";
    }
    const confirmCb = () => {
      Utils.exitFullscreen();
      AppCtrl.setCacheAccount(null);
      AppCtrl.setCachePassword(null);
      AppCtrl.middleServer().stop();
      setFunc(EFunction.login);
      // navigate('/login');
      if (checkOrientationInLobby) AppCtrl.FreeOrientationInLobby();
      let body = document.querySelector("body");
      if (!mobileMode) {
        //if (mobileMode) {
        body.style.backgroundImage = `url("img/loginpage/imgLoginBG.jpg?${Math.random()}")`;
      }
      if (Config?.urlBGImageHome) {
        if (Utils.isGifByExtension(Config.urlBGImageHome)) {
          document.body.style.backgroundImage = `url('${Config.urlBGImageHome}')`;
          document.body.style.backgroundSize = "100% 100%";
          // document.body.style.backgroundSize = "auto 100%";
          // document.body.style.backgroundRepeat = "no-repeat";
          // document.body.style.backgroundPosition = "center center";
        } else {
          document.body.style.backgroundImage = `url('${Config.urlBGImageHome}')`;
          document.body.style.backgroundSize = "100% 100%";
        }
      } else if (Config?.urlBGImage) {
        if (Utils.isGifByExtension(Config.urlBGImage)) {
          document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
          document.body.style.backgroundSize = "100% 100%";
          //document.body.style.backgroundSize = "contain";
          // document.body.style.backgroundSize = "auto 100%";
          // document.body.style.backgroundRepeat = "no-repeat";
          // document.body.style.backgroundPosition = "center center";
        } else {
          document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
          document.body.style.backgroundSize = "100% 100%";
          //document.body.style.backgroundSize = "contain";
        }
      }
    };
    if (!AppCtrl.isRobotMode()) {
      showAlert({
        title: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: yesText,
        cancelButtonText: noText,
        confirmCb,
      });
    }
  }

  function onExitAvatar() {
    const language = AppCtrl.getLanguage();
    let message;
    let yesText;
    let noText;
    if (language == LANGUAGE_TYPE.en_US) {
      message = `Go Back to '${Config.casinoName}', are you sure?`;
      yesText = "Yes";
      noText = "No";
    } else {
      message = `將回到'${Config.casinoName}'，確定嗎?`;
      yesText = "確定";
      noText = "取消";
    }
    const confirmCb = () => {
      AppCtrl.connectToServer(null, function () {
        AppCtrl.requestConfig();
        //send request token
        const account = AppCtrl.cacheAccount();
        const password = AppCtrl.cachePassword();
        AppCtrl.requestLoginToken(account, password, true, function (objRes) {
          const status = objRes.status;
          const language = AppCtrl.getLanguage();

          if (status == "success") {
            AppCtrl.stopUniPlay(function (objResStopUniPlay) {
              if (objResStopUniPlay) setUniPlayInfo(null);
              AppCtrl.stopUniPlayProcess(objResStopUniPlay).then(() => {
                console.log("stopUniPlayProcess 已執行完成");
              });
            });
          } else {
            const err = objRes.error;
            if (!AppCtrl.isRobotMode()) {
              showAlert({ title: err });
            }
          }
        });
      });
    };
    if (!AppCtrl.isRobotMode()) {
      showAlert({
        title: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: yesText,
        cancelButtonText: noText,
        confirmCb,
      });
    }
  }

  async function onChooseLobbyBtnClicked(e) {
    if (mLobbies) {
      const ui = e.currentTarget;
      const id = e.currentTarget.id;
      if (ui) {
        const prefix = "lobby_";
        const elementId = e.target.id;
        const lobbyName = elementId.replace(prefix, "");
        const language = AppCtrl.getLanguage();
        const userInfo = AppCtrl.userInfo();
        const guoZhaoInfo = userInfo.guoZhaoInfo();
        let msg = "";
        if (guoZhaoInfo != null && guoZhaoInfo.Lobby != lobbyName) {
          if (language == LANGUAGE_TYPE.en_US)
            msg = `you're playing Guo Zhao, please use lobby ${guoZhaoInfo.Lobby}.`;
          else msg = `您正過招中，請進入${guoZhaoInfo.Lobby}館。`;
        } else {
          AppCtrl.joinLobby(lobbyName);

          if (language == LANGUAGE_TYPE.en_US)
            msg = `Connect to ${lobbyName}\n Please wait..`;
          else msg = `正在連線至大廳${lobbyName}\n請稍候。`;
        }

        if (!AppCtrl.isRobotMode()) {
          // show alert
          showAlert({ title: msg, showConfirmButton: false, timer: 4000 });
        }
      } else {
        if (!AppCtrl.isRobotMode()) {
          showAlert({ title: `房號不存在 ${id} 該大廳已經不存在` });
        }
      }
    }
  }

  function onStartUniPlay(id) {
    return new Promise((resolve, reject) => {
      AppCtrl.startUniPlay(id, userUniPlayScores, function (objRes) {
        const status = objRes.status;
        if (status === "success") {
          AppCtrl.getUserScores();
          AppCtrl.SetNewLogin(true);
          AppCtrl.getUserInfo(function (obj) {
            AppCtrl.requestLobbies();
            setFunc(EFunction.winLobby); // show winLobbyPage for avatar to choose winLobbyManager
            resolve(); // 執行成功，回傳 Promise
          });
        } else {
          const err = objRes.error;
          if (!AppCtrl.isRobotMode()) {
            showAlert({ title: err });
          }

          reject(err); // 發生錯誤，回傳 Promise 失敗
        }
        setUniPlayStartDisabled(false); // 無論成功與否都執行
      });
    });
  }

  async function onChooseUniStoreBtnClicked(e) {
    if (!AppCtrl.isStartUniPlay()) {
      //!avatar) ) {
      const ui = e.currentTarget;
      const id = e.currentTarget.id;
      const userInfo = AppCtrl.userInfo();
      let str = id;
      let uniName = str.split("_")[1]; // 取得 "大滿貫"
      if (ui) {
        let strScores = userInfo.InCoins - userInfo.OutCoins;
        setScoresFormalToUniPlay(strScores);
        const scores = parseInt(strScores);
        if (scores > 0) {
          //AppCtrl.stopUniPlay(function (objResStopUniPlay) {
          AppCtrl.exchangeFormalToUniPlay(scores, function (objRes) {
            const status = objRes.status;
            if (status === "success") {
              console.log(`exchangeFormalToUniPlay :${scores}$`);
            }
            //onUniPlay();
            onStartUniPlay(uniName)
              .then(() => {
                console.log("startUniPlay 已完成");
              })
              .catch((error) => {
                console.error("startUniPlay 失敗:", error);
              });
          });
        } else {
          onStartUniPlay(uniName)
            .then(() => {
              console.log("startUniPlay 已完成");
            })
            .catch((error) => {
              console.error("startUniPlay 失敗:", error);
            });
        }
      } else {
        if (!AppCtrl.isRobotMode()) {
          showAlert({ title: `聯合營運 ${uniName} 不存在` });
        }
      }
    }
  }
  function registerEvent() {
    const prefix = "lobby_";
    if (mLobbies) {
      for (let i = 0; i < mLobbies.length; i++) {
        const uiBtnLobby = document.getElementById(
          `${prefix}${mLobbies[i].name}`
        );
        if (uiBtnLobby) {
          uiBtnLobby.style.display = "";
          uiBtnLobby.addEventListener("click", onChooseLobbyBtnClicked);
          uiLobbiesBtns.push(uiBtnLobby);
        } else {
          console.log(`uiBtnLobby id:${prefix}${mLobbies[i].name} is null`);
        }
      }
    }

    //Start
    //const prefix = "lobby_";
    const uniPlayList = AppCtrl.uniPlayList();
    uniPlayList.forEach((info) => {
      //info.name,
      const UniStore = `${info.name}`; //`uniStore`;
      const uiBtnUniStore = document.getElementById(`${prefix}${UniStore}`);
      if (uiBtnUniStore) {
        if (!AppCtrl.isStartUniPlay()) {
          //!avatar) )
          uiBtnUniStore.style.display = "";
          uiBtnUniStore.addEventListener("click", onChooseUniStoreBtnClicked);
          uiUniStoreBtns.push(uiBtnUniStore);
        }
      } else {
        console.log(`uiBtnUniStore id:${prefix}${UniStore} is null`);
      }
    });
    //End
    // const UniStore = `uniStore`;
    // const uiBtnUniStore = document.getElementById(`${prefix}${UniStore}`);
    // if (uiBtnUniStore) {
    //   uiBtnUniStore.style.display = "";
    //   uiBtnUniStore.addEventListener("click", onChooseUniStoreBtnClicked);
    //   uiUniStoreBtns.push(uiBtnUniStore);
    // } else {
    //   console.log(`uiBtnUniStore id:${prefix}${UniStore} is null`);
    // }
  }
  function unregisterEvent() {
    if (uiLobbiesBtns.length > 0) {
      for (let i = 0; i < uiLobbiesBtns.length; i++) {
        uiLobbiesBtns[i].removeEventListener("click", onChooseLobbyBtnClicked);
      }
      uiLobbiesBtns.splice(0, uiLobbiesBtns.length);
    }
  }
  function unregisterUniStoreEvent() {
    if (uiUniStoreBtns.length > 0) {
      for (let i = 0; i < uiUniStoreBtns.length; i++) {
        uiUniStoreBtns[i].removeEventListener(
          "click",
          onChooseUniStoreBtnClicked
        );
      }
      uiUniStoreBtns.splice(0, uiUniStoreBtns.length);
    }
  }

  function SliderBanner() {
    if (mBannerCounter === 0) return;
    const iIndex = 0;
    let slides = document.getElementById(`banner${iIndex}`);

    // 設置透明度為 0 (淡出)
    if (slides) {
      slides.style.opacity = "0.7";

      // 等待淡出完成後變更內容
      setTimeout(() => {
        mBannerIndex++;
        if (mBannerIndex >= mBannerCounter) mBannerIndex = 0;

        const mp4 = Config.bannersMobile[mBannerIndex].mp4
          ? Config.bannersMobile[mBannerIndex].mp4
          : "";
        const img = Config.bannersMobile[mBannerIndex].img
          ? Config.bannersMobile[mBannerIndex].img
          : "";

        // 更新源
        if (mp4?.trim() != "") {
          // 視頻處理...
        } else if (img?.trim() != "") {
          slides.src = `${img}?${Math.random()}`;
        }

        // 設置透明度為 1 (淡入)
        setTimeout(() => {
          slides.style.opacity = "1";
        }, 50); // 短暫延遲確保 DOM 更新
      }, 1000);
    }

    // mBannerIndex++;
    // if (mBannerIndex >= mBannerCounter) mBannerIndex = 0;
    // const mp4 = Config.bannersMobile[mBannerIndex].mp4
    //             ? Config.bannersMobile[mBannerIndex].mp4
    //             : "";
    // const img = Config.bannersMobile[mBannerIndex].img
    //             ? Config.bannersMobile[mBannerIndex].img
    //             : "";
    // if (mp4?.trim() != "") {
    //         const bannerVideoId = `banner${iIndex}`;
    //         const uiGameVideo = document.getElementById(bannerVideoId);
    //         if (uiGameVideo) {
    //           let url = mp4;
    //           url += "?loop=true";
    //           uiGameVideo.src = url + `?${Math.random()}`;
    //           uiGameVideo.style.objectFit = "fill";
    //           uiGameVideo.setAttribute("playsinline", null);
    //           uiGameVideo.setAttribute("WebKitPlaysInline", null);
    //           uiGameVideo.autoplay = "autoplay";
    //           uiGameVideo.WebKitPlaysInline = true;
    //           uiGameVideo.playsinline = true;
    //           uiGameVideo.preload = "auto";
    //           uiGameVideo.muted = "true";
    //           uiGameVideo.loop = "true";
    //         }
    // }
    // else if (img?.trim()  != "") {
    //   slides.src = `${img}?${Math.random()}`;
    // }
  }

  function rebuilLobbiesEvent() {
    let Lobbies = mLobbies ? mLobbies : AppCtrl.getLobbyInfos();

    if (Lobbies) {
      unregisterEvent();
      unregisterUniStoreEvent();
      buildLobbiesUI(Lobbies);

      const uiwinLobbies = document.getElementById("winLobbies");
      if (uiwinLobbies) {
        if (registerEventTimeout) clearTimeout(registerEventTimeout);
        registerEventTimeout = setTimeout(function () {
          registerEvent();
          // show ui
          //Start
          const prefix = "lobby_";
          const uniPlayList = AppCtrl.uniPlayList();
          uniPlayList.forEach((info) => {
            //info.name,
            const UniStore = `${info.name}`; //`uniStore`;
            const uiBtnUniStore = document.getElementById(
              `${prefix}${UniStore}`
            );
            if (uiBtnUniStore) {
              if (!AppCtrl.isStartUniPlay())
                //!avatar) )
                uiBtnUniStore.style.display = "";
              else {
                unregisterUniStoreEvent();
                uiBtnUniStore.remove();
              }
            }
          });
          //End
          registerEventTimeout = null;
        }, 1000);
      }
    }
  }
  function rebuilLobbies() {
    let Lobbies = mLobbies ? mLobbies : AppCtrl.getLobbyInfos();

    if (Lobbies) {
      unregisterEvent();
      unregisterUniStoreEvent();
      buildLobbiesUI(Lobbies);

      const uiwinLobbies = document.getElementById("winLobbies");
      if (uiwinLobbies) {
        if (registerEventTimeout) clearTimeout(registerEventTimeout);
        registerEventTimeout = setTimeout(function () {
          registerEvent();
          // show ui
          //Start
          const prefix = "lobby_";
          const uniPlayList = AppCtrl.uniPlayList();
          uniPlayList.forEach((info) => {
            //info.name,
            const UniStore = `${info.name}`; //`uniStore`;
            const uiBtnUniStore = document.getElementById(
              `${prefix}${UniStore}`
            );
            if (uiBtnUniStore) {
              if (!AppCtrl.isStartUniPlay())
                //!avatar) )
                uiBtnUniStore.style.display = "";
              else {
                unregisterUniStoreEvent();
                uiBtnUniStore.remove();
              }
            }
          });
          //End
          registerEventTimeout = null;
        }, 1000);
      }
    }
  }

  /**
   * 讓一個元素支援滑鼠拖曳來水平捲動
   * @param {HTMLElement} el
   */
  function enableDragScroll(el) {
    let isDown = false,
      startX,
      scrollLeft;

    function onDown(e) {
      isDown = true;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      // 捕获指针，保证后续事件能正确触发
      el.setPointerCapture(e.pointerId);
    }
    function onMove(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    }
    function onUp(e) {
      if (!isDown) return;
      isDown = false;
      // 释放指针捕获
      try {
        el.releasePointerCapture(e.pointerId);
      } catch {}
    }

    // 只要按下后才开始监听移动和释放，释放以后就彻底停止
    el.addEventListener("pointerdown", onDown);
    el.addEventListener("pointermove", onMove);
    el.addEventListener("pointerup", onUp);
    el.addEventListener("pointercancel", onUp);
    // 额外全局捕获保证松开时一定回调 onUp
    window.addEventListener("pointerup", onUp);
    window.addEventListener("pointercancel", onUp);

    // 禁止内部媒体拖动拦截事件
    el.querySelectorAll("img,video").forEach((media) =>
      media.addEventListener("dragstart", (e) => e.preventDefault())
    );
    // let isDown = false;
    // let startX;
    // let scrollLeft;

    // el.addEventListener('mousedown', e => {
    //   isDown = true;
    //   el.classList.add('active');
    //   startX = e.pageX - el.offsetLeft;
    //   scrollLeft = el.scrollLeft;
    // });

    // el.addEventListener('mouseleave', () => {
    //   isDown = false;
    //   el.classList.remove('active');
    // });

    // el.addEventListener('mouseup', () => {
    //   isDown = false;
    //   el.classList.remove('active');
    // });

    // el.addEventListener('mousemove', e => {
    //   if (!isDown) return;
    //   e.preventDefault();
    //   const x = e.pageX - el.offsetLeft;
    //   const walk = (x - startX) * 1.5;

    //   // 計算新的滾動位置
    //   const maxScroll = el.scrollWidth - el.offsetWidth;
    //   const newScrollLeft = Math.max(0, Math.min(maxScroll, scrollLeft - walk));
    //   el.scrollLeft = newScrollLeft;
    // });

    // // 設置容器樣式
    // el.style.overflowX = 'auto';
    // el.style.scrollBehavior = 'smooth';
    // el.style.width = '100%';
    // el.style.position = 'relative';
  }

  function verticalMode() {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;
    const prefix = "lobby_";
    const maxBtnInRaw = 2;
    const widthRate = parseInt(100 / maxBtnInRaw);
    const trunOffStreamGamebies = Config.trunOffStreamGame ? Config.trunOffStreamGame : false;

    const language = AppCtrl.getLanguage();

    let winLobbysContent = AppCtrl.showPlayerLevel()
      ? '<div style="position:relative; top:30px"><br>'
      : "<div>";

    if(trunOffStreamGamebies)
      return;
    if (mLobbies.length > 0) {
      const objStyle = {
        "min-width": "70px",
        "min-height": "70px",
        "border-style": "solid",
        "border-width": "1px",
        "border-radius": "10px",
        "object-fit": "contain",
        display: "none",
      };
      if (Config.showUniPlay && !AppCtrl.isStartUniPlay()) {
        const uniPlayList = AppCtrl.uniPlayList();
        for (let i = 0; i < mLobbies.length + uniPlayList.length; i++) {
          const rawId = i / maxBtnInRaw;
          const columnId = i % maxBtnInRaw;

          if (columnId === 0)
            winLobbysContent += '<div style="width:100%;text-align:center">';

          if (i < mLobbies.length) {
            const url = mLobbies[i].bgimg;
            let imgUrl = url
              ? url
              : `${window.location.origin}/fun888/img/gamelobby/imgBtnLobby620718Default.png`;
            if (AppCtrl.isStartUniPlay() === true) {
              const path = new URL(url).pathname;
              imgUrl = `${window.location.origin}${path}`;
            }

            winLobbysContent += `<img id="${prefix}${
              mLobbies[i].name
            }" src="${imgUrl}?${Math.random()}" style="width:${
              widthRate - 1
            }%;min-width:70px;min-height:70px;object-fit:contain;"/>`;
          }

          if (i >= mLobbies.length) {
            //Start
            const info = uniPlayList[i - mLobbies.length];
            //info.name,
            const uniStore = `${info.name}`; //`uniStore`;
            winLobbysContent += `<img id="${prefix}${uniStore}" type="image" src="${
              window.location
            }/img/lobbyui/uniStore${
              info.name
            }.png?${Math.random()}" style="width:${
              widthRate - 1
            }%;min-width:70px;min-height:70px;object-fit:contain;"/>`;
            //End
          }
          if (columnId === maxBtnInRaw - 1) winLobbysContent += "</div>";
        }
      } else {
        for (let i = 0; i < mLobbies.length; i++) {
          const rawId = i / maxBtnInRaw;
          const columnId = i % maxBtnInRaw;

          if (columnId === 0)
            winLobbysContent += '<div style="width:100%;text-align:center">';

          const url = mLobbies[i].bgimg;
          let imgUrl = url
            ? url
            : `${window.location.origin}/fun888/img/gamelobby/imgBtnLobby620718Default.png`;
          if (AppCtrl.isStartUniPlay() === true) {
            const path = new URL(url).pathname;
            imgUrl = `${window.location.origin}${path}`;
          }

          winLobbysContent += `<img id="${prefix}${
            mLobbies[i].name
          }" src="${imgUrl}?${Math.random()}" style="width:${
            widthRate - 1
          }%;min-width:70px;min-height:70px;object-fit:contain;"/>`;

          if (columnId === maxBtnInRaw - 1) winLobbysContent += "</div>";
        }
      }
    } else {
      winLobbysContent += '<span style="color:red">';
      if (language == LANGUAGE_TYPE.en_US)
        winLobbysContent += "system maintaining";
      else winLobbysContent += "系統維護中";
      winLobbysContent += "</span>";
    }

    winLobbysContent += "</div>";

    if (Config.webLink) {
      let webLinkContent = "<br>";
      for (let i = 0; i < Config.webLink.length; i++) {
        const url = Config.webLink[i].url;
        const img = Config.webLink[i].img;
        const video = Config.webLink[i].video;

        if (url !== "") {
          webLinkContent += `<a href="${url}" target="_blank">`;
        }
        if (img !== "") {
          webLinkContent += `<img src="${img}" style="width:75%;min-width:70px;min-height:70px;object-fit:contain;"/>`;
        }
        if (video !== "") {
          webLinkContent += '<div id="vd">';
          webLinkContent += `<iframe id="video${i}"></iframe>`;
          webLinkContent += "</div>";
        }
        if (url !== "") {
          webLinkContent += "</a>";
        }
      }
      winLobbysContent += webLinkContent;
    }

    const uiWinLobbys = document.getElementById("winLobbies");
    if (uiWinLobbys) uiWinLobbys.innerHTML = winLobbysContent;
    if (Config.webLink) {
      AppCtrl.setMachineTokenCB(() => {
        for (let i = 0; i < Config.webLink.length; i++) {
          const videoSource = Config.webLink[i].video;
          const gameVideoId = `video${i}`;
          const uiGameVideo = document.getElementById(gameVideoId);
          if (uiGameVideo && videoSource) {
            let url = startVideo(videoSource);
            uiGameVideo.src = url;
            uiGameVideo.style.display = "";
            uiGameVideo.style.objectFit = "fill";
            //處理自動撥放,iOS的部分就是把下面參數放到SRS html的<video></video>裡面即可

            uiGameVideo.setAttribute("playsinline", null);
            uiGameVideo.setAttribute("WebKitPlaysInline", null);
            uiGameVideo.autoplay = "autoplay";
            uiGameVideo.WebKitPlaysInline = true;
            uiGameVideo.playsinline = true;
            uiGameVideo.preload = "auto";
            uiGameVideo.muted = "true";
          }
        }
      });
    }
  }
  function horizontalMode() {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;
    const prefix = "lobby_";

    let body = document.querySelector("body");
    body.style.backgroundImage = `url("img/loginpage/Lobby.jpg?${Math.random()}")`;
    const uiContent = document.getElementById("content_horizontal");
    if (uiContent) {
      uiContent.style.paddingTop = "90px";
      uiContent.style.paddingBottom = "85px";
      uiContent.style.paddingLeft = "65px";
      uiContent.style.paddingRight = "65px";
    }
    const uiWinLobbys = document.getElementById("winLobbies");
    uiWinLobbys.innerHTML = ""; // 清空內容;
    // 修改容器樣式，讓內容從左側開始
    uiWinLobbys.style.width = "100%";
    uiWinLobbys.style.display = "block"; // 改為 block
    uiWinLobbys.style.overflowX = "auto";

    const maxWidthItemInRaw = 2; //最大一行有2個按鈕
    const widthRate = parseInt(100 / maxWidthItemInRaw); //widthRate=>100/2=50

    //計算內容高度
    const contentHeight = deviceHeight - 90 - 85; //BTNTopBar-horizontal(40px)+broadcastPanel(30px);+content_horizontal(85px)
    const itemWidth = deviceWidth * parseFloat(widthRate / 100); //itemWidth=>計算一個按鈕的實際寬度deviceWidth*0.5
    const bannerHeight = contentHeight * 0.8; //ContentHeight * 0.8;
    const bannerWidth = bannerHeight * (16 / 10);
    let topOffset = (contentHeight - bannerHeight) / 2; // 讓他能夠上下置中
    // 計算內容總寬度，確保可以滾動到中間
    let totalContentWidth = 0;
    let posLeftOffset = 0;
    let tempContent = "";
    mbannersContent = "";

    if (Config.bannersMobile && mbannersContent?.trim() === "") {
      mbannersContent = "";
      mBannerCounter = Config.bannersMobile.length;
      // 以 16:9 算出高度、寬度

      //for (let iIndex = 0; iIndex < mBannerCounter; iIndex++) {
      let iIndex = 0;
      let bannersContent = "";
      let StyleBannerContainer = `position:relative;left:0px;top:0px;z-index:2;
                           width:${bannerWidth}px;padding-bottom:0px;`;
      let styleImgContent = "";

      styleImgContent = `position:absolute; left:0px; top:${topOffset}px; 
                    width:${bannerWidth}px;height:${bannerHeight}px;display:block;
                    transition: opacity 1s ease-in-out;`; // 添加過渡效果
      // styleImgContent = `position:absolute; left:0px; top:${topOffset}px;
      //             width:${bannerWidth}px;height:${bannerHeight}px;display:block;`;
      // if (iIndex === 0)
      //   styleImgContent = `position:absolute; left:0px; top:${topOffset}px; width:${bannerWidth}px;height:${bannerHeight}px;display:block;`;
      // else
      //   styleImgContent = `position:absolute; left:0px; top:${topOffset}px; width:${bannerWidth}px;height:${bannerHeight}px;display:none;`;

      /*
        -webkit-animation-name: fade;
        -webkit-animation-duration: 1.5s;
        animation-name: fade;
        animation-duration: 1.5s;
        */
      bannersContent = `<div style="${StyleBannerContainer}">`;
      const mp4 = Config.bannersMobile[iIndex].mp4
        ? Config.bannersMobile[iIndex].mp4
        : "";
      const img = Config.bannersMobile[iIndex].img
        ? Config.bannersMobile[iIndex].img
        : "";
      if (mp4 != "") {
        bannersContent += `<video controls id="banner${iIndex}" class="${styles.banner}" style="${styleImgContent}"/>`;
      } else if (img != "") {
        bannersContent += `<img id="banner${iIndex}" src="${img}?${Math.random()}" class="${
          styles.banner
        }" style="${styleImgContent}"/>`;
      }
      bannersContent += `</div>`;
      mbannersContent += bannersContent;
      //}
      tempContent = mbannersContent;
      if (mSliderBannerTimer) clearInterval(mSliderBannerTimer);
      mSliderBannerTimer = setInterval(SliderBanner, 5000);
      totalContentWidth += bannerWidth + 20; //+20是為了讓他有點間距
    }

    uiWinLobbys.innerHTML += tempContent;
    tempContent = ""; //清空tempContent等下要重新組合

    //添加 Bonus 看板 (如果啟用)
    if (Config?.showJackpot && Config?.urlBonus?.trim() !== "") {
      // 計算垂直置中所需的 top 值
      const jackpotHeight = contentHeight * 0.8;
      const jackpotWidth = jackpotHeight * (16 / 9);
      const topOffsetJackpot = (contentHeight - jackpotHeight) / 2;

      let jackpotContent = `
        <!-- 外層container -->
        <div style="position:relative; left:${totalContentWidth}px; top:0px; z-index:2; width:${jackpotWidth}px; padding-bottom:0px;">
          <!-- 內層content -->  
          <div id="bonusContainer" style="position:absolute; left:0px; top:${topOffsetJackpot}px; width:${jackpotWidth}px; height:${jackpotHeight}px; overflow:hidden;">
            <iframe 
              id="bonusIframe"
              src="${Config.urlBonus}/bonusClient/bonus?isShowBg=true"
              style="width:1920px; height:1080px; transform-origin:0 0; position:absolute; top:0; left:0; border:none;">
            </iframe>
            <!-- 添加透明遮罩層 -->
            <div id="iframeMask" style="position:absolute; top:0; left:0; width:100%; height:100%; z-index:10;"></div>
          </div>
        </div>
      `;

      tempContent += jackpotContent;
      totalContentWidth += jackpotWidth + 20;

      // 使用 setTimeout 確保 DOM 已更新後計算縮放
      setTimeout(() => {
        const container = document.getElementById("bonusContainer");
        const iframe = document.getElementById("bonusIframe");

        if (container && iframe) {
          const containerWidth = container.clientWidth;
          const containerHeight = container.clientHeight;
          const scaleX = containerWidth / 1920;
          const scaleY = containerHeight / 1080;
          const scale = Math.min(scaleX, scaleY);

          iframe.style.transform = `scale(${scale})`;
        }
      }, 100);
    }

    uiWinLobbys.innerHTML += tempContent;
    tempContent = ""; //清空tempContent等下要重新組合

    // //------------------UserInfos------------------
    const mainSettings = AppCtrl.mainSettings();
    const language = AppCtrl.getLanguage();
    const userInfo = AppCtrl.userInfo();
    const goldName = Config.gold[language];
    const silverName = Config.silver[language];
    const wainZhusName = Config.wainZhuName[language];
    const paiedAwardName = Config.paiedAwardName[language];
    const betRewardName = Config.betRewardName[language];
    const guoZhaoInfo = userInfo.GuoZhaoInfo;
    const specialCoinName = Config.specialCoins[language];
    const specialCoinNameA = Config.specialCoinsA[language];

    const infoHeight = contentHeight * 0.6;
    const infoWidth = infoHeight;
    const topOffsetInfo = (contentHeight - infoHeight) / 2;

    let userInfosContent = "";
    let StyleInfosContainer = `position:relative;left:${totalContentWidth}px;top:0px;
                              z-index:2;width:${infoWidth}px;padding-bottom:0px;`;
    let StyleInfosContent = `position:absolute;left:0px;top:${topOffsetInfo}px;
                         width:${infoWidth}px;height:${infoHeight}px;
                         color:white;font-size:30px;text-align:left;
                         padding-top:50px; padding-left:50px;
                         background-color:rgba(0, 0, 0, 0.8); border-radius:10px`;
    userInfosContent = `<div style="${StyleInfosContainer}">`;

    userInfosContent += `<div id="userInfos_horizontalmode" style="${StyleInfosContent}">`;
    let content = "";
    //顯示玩家暱稱
    if (language == LANGUAGE_TYPE.en_US) {
      content += `<div>User: ${userInfo.nickName()}`;
      if (guoZhaoInfo != null) {
        const machineName = guoZhaoInfo.Machine
          ? guoZhaoInfo.Machine
          : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
        content += ` (on Guo Zhao, Machine ${machineName} of Lobby ${guoZhaoInfo.Lobby})`;
      } else if (userInfo.BindedMachines.length > 0) {
        const lockedMachine = userInfo.BindedMachines[0];
        const machineName = lockedMachine.MachineName
          ? lockedMachine.MachineName
          : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
        content += ` (use Machine ${machineName} of Lobby ${lockedMachine.Lobby})`;
      }
      content += "</div>";
    } else {
      const now = new Date();
      const dateStr = now.toLocaleString("zh-TW", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
      content += `<div>${dateStr}</div>`;

      content += `<div>玩家: ${userInfo.nickName()}`;
      if (guoZhaoInfo != null) {
        const machineName = guoZhaoInfo.Machine
          ? guoZhaoInfo.Machine
          : `${guoZhaoInfo.DeviceId + 1}_${guoZhaoInfo.MachineId + 1}`;
        content += ` (正在${guoZhaoInfo.Lobby}館的機台${machineName}過招中)`;
      } else if (userInfo.BindedMachines.length > 0) {
        const lockedMachine = userInfo.BindedMachines[0];
        const machineName = lockedMachine.MachineName
          ? lockedMachine.MachineName
          : `${lockedMachine.DeviceId + 1}_${lockedMachine.MachineId + 1}`;
        content += ` (使用${lockedMachine.Lobby}館的機台${machineName})`;
      }
      content += "</div>";
    }

    //顯示玩家的金幣數量
    content += `<div>${goldName}: ${(
      userInfo.InCoins - userInfo.OutCoins
    ).toLocaleString()}</div>`;

    //顯示玩家的銀幣數量
    if (Config.trialCoins) {
      content += `<div>${silverName}: ${(
        userInfo.InTrialCoins - userInfo.OutTrialCoins
      ).toLocaleString()}</div>`;
    }

    //顯示玩家的特殊幣數量
    if (Config.showSpecialCoin) {
      content += `<div>${specialCoinName}: ${(
        userInfo.InSpecialCoins - userInfo.OutSpecialCoins
      ).toLocaleString()}</div>`;
    }
    if (Config.showSpecialCoinA) {
      content += `<div>${specialCoinNameA}: ${(
        userInfo.InSpecialCoinsA - userInfo.OutSpecialCoinsA
      ).toLocaleString()}</div>`;
    }

    //顯示玩家的每日贈獎數量
    if (userInfo.PaiedAward != null) {
      content += `<div">${paiedAwardName}: ${userInfo.PaiedAward.toLocaleString()}
        </div>`;
    }

    //顯示玩家返水數量
    if (mainSettings.ShowBetReward && userInfo.BetReward != null) {
      content += `<div>${betRewardName}: ${userInfo.BetReward.toLocaleString()}
        </div>`;
    }

    //顯示玩家萬珠數量,目前已經停用
    if (Config.wainZhu && userInfo.WainZhus != null) {
      if (typeof userInfo.WainZhus != "object")
        AppCtrl.setWainZhu(userInfo.WainZhus);
      const wainZhu = AppCtrl.WainZhu();
      content += `<div>${wainZhusName}:${wainZhu.toLocaleString()}
        </div>`;
    }

    //顯示玩家等級
    const showPlayerLevel = AppCtrl.showPlayerLevel();
    if (showPlayerLevel > 0) {
      //img:"img/gamelobby/銀卡.png",
      const permission =
        userInfo.Permission >= showPlayerLevel
          ? showPlayerLevel
          : userInfo.Permission;
      const imgLevel = `img/gamelobby/VipCard${permission.toString()}.png`;
      const cardWidth = 0.3 * infoWidth; // 30% of infoWidth

      content += `<div id='VipCard'> 
                  <img src="${imgLevel}" style="position:absolute;right:0px;top:${topOffsetInfo}px;
                  padding-top:200px; width:${cardWidth}px; object-fit:contain"/>
                  </div>`;
    }
    userInfosContent += content;
    userInfosContent += `</div></div>`;
    uiWinLobbys.innerHTML += userInfosContent;
    totalContentWidth += infoWidth + 60; //+60是為了讓他有點間距
    // //------------------End UserInfos------------------

    //橫式版的Lobby按鈕
    if (mLobbies.length > 0) {
      const lobbyHeight = contentHeight * 0.5;
      const lobbyWidth = lobbyHeight;
      const topOffsetLobby = (contentHeight - lobbyHeight) / 2;

      let lobbyBtn = "";

      for (let i = 0; i < mLobbies.length; i++) {
        let StyleLobbyContainer = `position:relative;left:${totalContentWidth}px;
                                  top:0px;z-index:2;width:${lobbyWidth}px;padding-bottom:0px;`;
        let StyleLobbyImgContent = `position:absolute; left:0px; top:${topOffsetLobby}px; 
                                    width:${lobbyWidth}px;height:${lobbyHeight}px;`;
        lobbyBtn = `<div style="${StyleLobbyContainer}">`;

        const imgUrl = mLobbies[i].bgimg
          ? mLobbies[i].bgimg
          : `${
              window.location.origin
            }/fun888/img/gamelobby/imgBtnLobby620718Default.png?${Math.random()}`;
        lobbyBtn += `<img id="${prefix}${
          mLobbies[i].name
        }" src="${imgUrl}?${Math.random()}" style="${StyleLobbyImgContent};"/>`;

        lobbyBtn += `</div>`;
        uiWinLobbys.innerHTML += lobbyBtn;

        totalContentWidth += lobbyWidth + 20;
      }
    }
    //End-橫式版的Lobby按鈕

    if (Config.showUniPlay && !AppCtrl.isStartUniPlay()) {
      //!avatar)  {
      const lobbyHeight = contentHeight * 0.5;
      const lobbyWidth = lobbyHeight;
      const topOffsetLobby = (contentHeight - lobbyHeight) / 2;
      const uniPlayList = AppCtrl.uniPlayList();

      let UniPlayBtn = "";

      let StyleUniPlayContainer = `position:relative;left:${totalContentWidth}px;
                                    top:0px;z-index:2;width:${lobbyWidth}px;padding-bottom:0px;`;
      let StyleUniPlayImgContent = `position:absolute; left:0px; top:${topOffsetLobby}px; 
                                    width:${lobbyWidth}px;height:${lobbyHeight}px;`;
      UniPlayBtn = `<div style="${StyleUniPlayContainer}">`;

      const defaultUniPlayImg = `${window.location.origin}/fun888/img/lobbyui/uniPlay.png`;
      for (let i = 0; i < uniPlayList.length; i++) {
        const info = uniPlayList[i];
        const uniPlayImg = `${window.location.origin}/fun888/img/lobbyui/uniStore${info.name}.png`;
        const imgUrl = uniPlayImg ? uniPlayImg : defaultUniPlayImg;
        const uniStore = `${info.name}`; //`uniStore`;
        UniPlayBtn += `<img id="${prefix}${uniStore}" 
        type="image" src="${imgUrl}?${Math.random()}" style="${StyleUniPlayImgContent};"/>`;
      }
      UniPlayBtn += `</div>`;
      uiWinLobbys.innerHTML += UniPlayBtn;
      totalContentWidth += lobbyWidth + 20;
    }
    // } else {
    //   let Information = "";
    //   let TextContent = "";
    //   let StyleTextMain = `position:relative;left:${totalContentWidth}px;top:0px;z-index:2;width:${widthRate - 1
    //     }%;padding-bottom:0px;`;
    //   let StyleText = `position:absolute;left:0px;top:${contentHeight / 2
    //     }px;width:100%;color:red;font-size:26px;`;
    //   //let StyleText = `position:absolute;left:${itemWidth/2}px;top:${CMPHeight/2}px;width:100%;text-align: center;color:red;font-size:26px;`;
    //   TextContent = `<div style="${StyleTextMain}">`;
    //   if (language == LANGUAGE_TYPE.en_US) Information = "system maintaining";
    //   else Information = "系統維護中";

    //   TextContent += `<span style="${StyleText}">${Information}</span >`;

    //   TextContent += `</div>`;
    //   uiWinLobbys.innerHTML += TextContent;
    //   posLeftOffset++;
    //   totalContentWidth += itemWidth;

    enableDragScroll(uiWinLobbys);
    // if (Config.bannersMobile) {
    //   if (mbannersContent?.trim() !== "") {
    //     tempContent += mbannersContent;
    //     for (let i = 0; i < Config.bannersMobile.length; i++) {
    //       const mp4Source = Config.bannersMobile[i].mp4
    //         ? Config.bannersMobile[i].mp4
    //         : "";
    //       const bannerVideoId = `banner${i}`;
    //       const uiGameVideo = document.getElementById(bannerVideoId);
    //       if (uiGameVideo && mp4Source) {
    //         let url = mp4Source;
    //         url += "?loop=true";
    //         uiGameVideo.src = url + `?${Math.random()}`;
    //         //uiGameVideo.style.display = "";
    //         uiGameVideo.style.objectFit = "fill";
    //         uiGameVideo.setAttribute("playsinline", null);
    //         uiGameVideo.setAttribute("WebKitPlaysInline", null);
    //         uiGameVideo.autoplay = "autoplay";
    //         uiGameVideo.WebKitPlaysInline = true;
    //         uiGameVideo.playsinline = true;
    //         uiGameVideo.preload = "auto";
    //         uiGameVideo.muted = "true";
    //         uiGameVideo.loop = "true";
    //       }
    //     }
    //     totalContentWidth += bannerWidth;
    //   }
    //   if (mSliderBannerTimer) clearInterval(mSliderBannerTimer);
    //   mSliderBannerTimer = setInterval(SliderBanner, 5000);

    // } else {
    //   //totalContentWidth += bannerWidth * 0.9 * -1;
    //   totalContentWidth += 100;
    // }

    // if (Config.LivePlayMobile) {
    //   let LivePlayMobile = "";
    //   for (let K = 0; K < Config.LivePlayMobile.length; K++) {
    //     // let LiveHeight = CMPHeight;
    //     // let LiveWidth = itemWidth * 0.7;
    //     let LiveHeight = parseFloat(
    //       Config.LivePlayMobile[K].height
    //         ? Config.LivePlayMobile[K].height
    //         : "1"
    //     );
    //     LiveHeight = contentHeight * LiveHeight;
    //     let LiveWidth = parseFloat(
    //       Config.LivePlayMobile[K].width
    //         ? Config.LivePlayMobile[K].width
    //         : "1"
    //     );
    //     LiveWidth = itemWidth * LiveWidth;
    //     let StyleLivePlayMain = `position:relative;left:${totalContentWidth}px;top:0px;z-index:2;width:${widthRate - 1
    //       }%;padding-bottom:0px;`;
    //     let styleLivePlay = `position:absolute; left:0px; top:0px; width:${LiveWidth}px;height:${LiveHeight}px`;

    //     totalContentWidth += LiveWidth * 1.2;

    //     LivePlayMobile = `<div style="${StyleLivePlayMain}">`;
    //     const video = Config.LivePlayMobile[K].video
    //       ? Config.LivePlayMobile[K].video
    //       : "";
    //     const img = Config.LivePlayMobile[K].img
    //       ? Config.LivePlayMobile[K].img
    //       : "";
    //     if (video != "") {
    //       LivePlayMobile += `<iframe id="Live_${K}" style="${styleLivePlay}"/>`;
    //     }
    //     if (img != "") {
    //       LivePlayMobile += `<img id="Live_${K}" src="${img}?${Math.random()}" style="${styleLivePlay}"/>`;
    //     }
    //     LivePlayMobile += `</div>`;
    //     uiWinLobbys.innerHTML += LivePlayMobile;
    //   }
    // }

    // if (Config.LivePlayMobile) {
    //   AppCtrl.setMachineTokenCB(() => {
    //     for (let i = 0; i < Config.LivePlayMobile.length; i++) {
    //       const videoSource = Config.LivePlayMobile[i].video
    //         ? Config.LivePlayMobile[i].video
    //         : "";
    //       const gameVideoId = `Live_${i}`;
    //       const uiGameVideo = document.getElementById(gameVideoId);
    //       if (uiGameVideo && videoSource) {
    //         let url = startVideo(videoSource);
    //         uiGameVideo.src = url;
    //         uiGameVideo.style.display = "";
    //         uiGameVideo.style.objectFit = "fill";
    //         //處理自動撥放,iOS的部分就是把下面參數放到SRS html的<video></video>裡面即可

    //         uiGameVideo.setAttribute("playsinline", null);
    //         uiGameVideo.setAttribute("WebKitPlaysInline", null);
    //         uiGameVideo.autoplay = "autoplay";
    //         uiGameVideo.WebKitPlaysInline = true;
    //         uiGameVideo.playsinline = true;
    //         uiGameVideo.preload = "auto";
    //         uiGameVideo.muted = "true";
    //       }
    //     }
    //   });
    // }
    // enableDragScroll(uiWinLobbys);
  }

  function buildLobbiesUI(arrLobbies) {
    mLobbies = arrLobbies;

    if (mobileMode) {
      verticalMode();
    } else {
      horizontalMode();
    }
  }

  function startVideo(videoSource) {
    const keyWord = "://";
    let index = videoSource.indexOf(keyWord);
    if (index >= 0) videoSource = videoSource.substr(index + keyWord.length);

    let strParams = videoSource.split("/");
    let videoDomain = strParams[0];
    index = videoDomain.indexOf(":");
    if (index >= 0) videoDomain = videoDomain.substr(0, index);

    // rebuild video source
    let videoUrl = `${videoDomain}`;
    for (let i = 1; i < strParams.length; i++) {
      videoUrl += `/${strParams[i]}`;
    }

    strParams = videoUrl.split("/");
    let videoId = strParams[strParams.length - 1];
    let url = `${protocolRef.current}://${videoDomain}/?id=${videoId}&autostart=true&muted=true`;
    const account = AppCtrl.getAccount();
    const machineToken = AppCtrl.getMachineToken();
    const connectionId = AppCtrl.middleServer().connectionId();
    const lobby = AppCtrl.GetDefaultLobbyName();

    if (machineToken && machineToken != undefined) {
      AppCtrl.setMachineTokenInLobby(false);
      url += `&token=${machineToken}&account=${account}&connectionId=${connectionId}&lobby=${lobby}`;
    }
    return url;
  }

  const onClickAtgLobby = () => {
    AppCtrl.switchPage(EPage.atgLobby);
  };

  const onClickRsgLobby = () => {
    AppCtrl.switchPage(EPage.rsgLobby);
  };

  const onClickAtgGame = (game) => {
    const userInfo = AppCtrl.userInfo();
    if (userInfo.InCoins - userInfo.OutCoins <= 0) {
      showAlert({ title: "您的帳號餘額不足，無法進入ATG遊戲" });
      return;
    }
    AppCtrl.requestJoinAtgGames(game.code);
    AppCtrl.switchPage(EPage.atgGame);
  };

  return (
    <div id="winLobbyPageFrame">
      {/* 機器人模式倒數：右上角固定顯示 */}
      {AppCtrl.isRobotMode() && robotLobbyCountdown !== null && (
        <div
          style={{
            position: "fixed",
            right: "8px",
            top: "8px",
            zIndex: 9999,
            color: "#fff",
            background: "rgba(0,0,0,0.6)",
            padding: "6px 10px",
            borderRadius: "4px",
            fontWeight: "bold",
            pointerEvents: "none",
          }}
        >
          自動進入倒數: {formatCountdown(robotLobbyCountdown)}
        </div>
      )}
      {!mobileMode ? (
        <div id="winLobbyPage" className={styles.winLobbyPage_horizontal}>
          <div id="mainAreaInLobby" className={styles.mainArea_horizontal}>
            <div
              className={styles.header_horizontal}
              style={{ backgroundImage: "url(img/lobbyui/TopBar.png)" }}
            >
              {!avatar ? (
                <input
                  id="exitButton"
                  type="image"
                  src="img/lobbyui/exit.png"
                  style={{
                    margin: "0 1px",
                    float: "right",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={onExitGame}
                ></input>
              ) : (
                <input
                  id="exitavatarButton"
                  type="image"
                  src="img/lobbyui/avatar.png"
                  style={{
                    margin: "0 5px",
                    float: "right",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={onExitAvatar}
                ></input>
              )}
              <input
                id="chatButton"
                type="image"
                src="img/lobbyui/chat.png"
                style={{
                  margin: "0 1px",
                  float: "left",
                  width: "35%",
                  maxWidth: "50px",
                  maxHeight: "50px",
                }}
                onClick={onChat}
              ></input>
              <label
                id="showTitle"
                style={{
                  paddingLeft: "10px",
                  margin: "15px auto",
                  float: "center",
                  fontSize: "24px",
                }}
              ></label>
            </div>
            <div className={styles.broadcastbar_horizontal}>
              <BroadcastPanel />
            </div>
            <div id="content_horizontal" className={styles.content_horizontal}>
              <div id="winLobbies" className={styles.lobbies_horizontal}></div>
            </div>
            <div
              className={styles.footer_horizontal}
              style={{ backgroundImage: "url(img/lobbyui/BottomBar.png)" }}
            >
              {!avatar ? (
                <div className={styles.functionPanel_functionPanel_horizontal}>
                  <input
                    id="btnSettings"
                    type="image"
                    src="img/lobbyui/setting.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onSettings}
                  ></input>
                  <input
                    id="btnWallet"
                    type="image"
                    src="img/lobbyui/wallet.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onWallet}
                  ></input>
                  <input
                    id="btnRecords"
                    type="image"
                    src="img/lobbyui/record.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onRecords}
                  ></input>
                  <input
                    id="btnStore"
                    type="image"
                    src="img/lobbyui/store.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onStore}
                  ></input>
                  <input
                    id="btnUniPlay"
                    type="image"
                    src="img/lobbyui/uniPlay.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onUniPlay}
                  ></input>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div id="winLobbyPage" className={styles.winLobbyPage}>
          <div id="mainAreaInLobby" className={styles.mainArea}>
            <div
              className={styles.header}
              style={{ backgroundImage: "url(img/lobbyui/TopBar.png)" }}
            >
              {!avatar ? (
                <input
                  id="exitButton"
                  type="image"
                  src="img/lobbyui/exit.png"
                  style={{
                    margin: "0 1px",
                    float: "right",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={onExitGame}
                ></input>
              ) : (
                <input
                  id="exitavatarButton"
                  type="image"
                  src="img/lobbyui/avatar.png"
                  style={{
                    margin: "0 5px",
                    float: "right",
                    width: "35%",
                    maxWidth: "50px",
                    maxHeight: "50px",
                  }}
                  onClick={onExitAvatar}
                ></input>
              )}
              <input
                id="chatButton"
                type="image"
                src="img/lobbyui/chat.png"
                style={{
                  margin: "0 1px",
                  float: "left",
                  width: "35%",
                  maxWidth: "50px",
                  maxHeight: "50px",
                }}
                onClick={onChat}
              ></input>
              <label
                id="showTitle"
                style={{
                  paddingLeft: "10px",
                  margin: "15px auto",
                  float: "center",
                  fontSize: "24px",
                }}
              ></label>
            </div>
            <div className={styles.broadcastbar}>
              <BroadcastPanel />
            </div>
            <div className={styles.content}>
              <Banners />
              {/* <div className={styles.userInfoRow} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div
                  id="userInfos"
                  className={styles.userInfoPage}
                  style={{ marginRight: "16px" }} // 可依需求調整間距
                ></div>
                {(() => {
                  const show = AppCtrl.showPlayerLevel();
                  if (!show) return null;
                  const userInfo = AppCtrl.userInfo();
                  const permission = userInfo.Permission >= show ? show : userInfo.Permission;
                  const vipImg = `img/gamelobby/VipCard${permission}.png`;
                  return (
                    <div className={styles.vipCardInline} id="VipCard">
                       <img src={vipImg} alt="VIP" style={{ height: "48px" }} />
                    </div>
                  );
                })()}
              </div> */}
              <div className={styles.userInfoRow}>
                <div id="userInfos" className={styles.userInfoPage}></div>

                {(() => {
                  const show = AppCtrl.showPlayerLevel();
                  if (!show) return null;
                  const userInfo = AppCtrl.userInfo();
                  const permission =
                    userInfo.Permission >= show ? show : userInfo.Permission;
                  const vipImg = `img/gamelobby/VipCard${permission}.png`;
                  return (
                    <div className={styles.vipCardInline} id="VipCard">
                      <img src={vipImg} alt="VIP" />
                    </div>
                  );
                })()}
              </div>
              <div id="winLobbies" className={styles.lobbies}></div>
              <div className={styles.thirdPartyLobbies}>
                {atgGames && atgGames.length > 0 && (
                  <img
                    src="img/lobbyui/atgLobby.gif"
                    className={styles.thirdPartyLobbyImg}
                    onClick={onClickAtgLobby}
                  />
                )}
                {rsgGames && rsgGames.length > 0 && (
                  <img
                    src="img/lobbyui/thorLobby.gif"
                    className={styles.thirdPartyLobbyImg}
                    onClick={onClickRsgLobby}
                  />
                )}
              </div>

              {Config?.showJackpot && Config?.urlBonus?.trim() !== "" && (
                <div
                  ref={containerRef}
                  style={{
                    maxWidth: "600px",
                    height: "350px",
                    position: "relative",
                  }}
                >
                  <iframe
                    ref={iframeRef}
                    src={`${Config.urlBonus}/bonusClient/bonus?isShowBg=false`}
                    style={{
                      width: "1920px",
                      height: "1080px",
                      transformOrigin: "0 0",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      border: "none",
                    }}
                  />
                </div>
              )}
              <div id="webLinks" className={styles.webLinks}></div>
            </div>
            <div
              className={styles.footer}
              style={{ backgroundImage: "url(img/lobbyui/BottomBar.png)" }}
            >
              {!avatar ? (
                <div className={styles.functionPanel}>
                  <input
                    id="btnSettings"
                    type="image"
                    src="img/lobbyui/setting.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onSettings}
                  ></input>
                  <input
                    id="btnWallet"
                    type="image"
                    src="img/lobbyui/wallet.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onWallet}
                  ></input>
                  <input
                    id="btnRecords"
                    type="image"
                    src="img/lobbyui/record.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onRecords}
                  ></input>
                  <input
                    id="btnStore"
                    type="image"
                    src="img/lobbyui/store.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onStore}
                  ></input>
                  <input
                    id="btnUniPlay"
                    type="image"
                    src="img/lobbyui/uniPlay.png"
                    style={{
                      margin: "0 1px",
                      float: "center",
                      width: "19%",
                      maxHeight: "75px",
                    }}
                    onClick={onUniPlay}
                  ></input>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default WinLobbyPage;
